import React, { memo } from 'react';

interface ToggleOption<T> {
  value: T;
  label: string;
}

interface DetailPageToggleGroupProps<T extends string> {
  options: ToggleOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

function DetailPageToggleGroupInner<T extends string>({
  options,
  value,
  onChange,
}: DetailPageToggleGroupProps<T>) {
  return (
    <div className="flex gap-4 w-[424px]">
      {options.map((option) => {
        const selected = value === option.value;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            className={`
              flex-1 h-16 rounded-2xl text-[28px] font-medium transition-all border-2
              ${selected
                ? 'bg-white/30 text-white border-white/35'
                : 'bg-white/[0.08] text-white/80 border-white/[0.12] hover:bg-white/14 hover:border-white/22'
              }
            `}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}

export const DetailPageToggleGroup = memo(DetailPageToggleGroupInner) as typeof DetailPageToggleGroupInner;
